import Cookies from 'js-cookie'
import {getUserToken} from './user_auth'

export function getCSRF(){
  var header              = Object()
  header['X-CSRFToken']   = Cookies.get('csrftoken')
  return header
}

export function getToken(){
  var header              = Object()
  if(getUserToken() !== '') header['Authorization'] = `Token ${getUserToken()}`
  return header
}

export function getCSRFHeader(){
  return {
    headers : getCSRF()
  }
}

export function getTokenHeader(){
  return{
    headers : getToken()
  }
}

export default function getHeader(){
  return {
    headers : Object.assign(getCSRF(), getToken())
  }
}